export default "__VITE_ASSET__BSdQ986X__"